import { render } from "./UpdateSuppliers.vue?vue&type=template&id=670c764e"
import script from "./UpdateSuppliers.vue?vue&type=script&lang=js"
export * from "./UpdateSuppliers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__